import React from "react";
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import { Helmet } from 'react-helmet';
import styles from './page.module.css';


export default ({ data }) => {
  const post = data.markdownRemark;
  const metadata = data.site.siteMetadata;
  return (
    <div>
      <Helmet>
        <title>{post.frontmatter.title + ' - ' + metadata.title}</title>
      </Helmet>
      <div className={styles.title} >
        <h1>{post.frontmatter.title}</h1>
      </div>
      <p>{'Released ' + post.frontmatter.date}</p>
      <section dangerouslySetInnerHTML={{ __html: post.html }} />
    </div>
  );
};

export const query = graphql`
  query PageQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date(formatString: "MMMM D, YYYY")
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/page.js